import React, { ChangeEvent, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

interface TextFieldProps {
  align?: 'right'
  name?: string
  placeholder?: string
  size?: 'sm' | 'md'
  type?: string
  value?: string | number
  defaultValue?: string | number
  onChange?: (value: string) => void
}

const Field = styled.div<TextFieldProps>`
  ${({ theme, size, align }) => css`
    input {
      color: ${theme.colors.black};
      background: ${theme.colors.greySemiLight};
      padding: 8px 16px;

      ${size === 'sm' &&
      css`
        border-radius: 29px;
        font-size: 12px;
        line-height: 1.5;
        height: 32px;
      `}

      ${align === 'right' &&
      css`
        text-align: right;
      `}
    }
  `}
`

const TextField = (props: TextFieldProps) => {
  const { type = 'text', size = 'md', align, onChange, value, placeholder, defaultValue = '' } = props
  const [currentValue, setCurrentValue] = useState<string | number>(defaultValue)

  useEffect(() => {
    if (typeof value !== 'undefined') {
      setCurrentValue(value)
    }
  }, [value])

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event
    setCurrentValue(value)
    if (onChange) onChange(value)
  }

  return (
    <Field size={size} align={align}>
      <input type={type} value={currentValue} placeholder={placeholder} onChange={handleChange} />
    </Field>
  )
}

export default TextField
